module.exports = __webpack_public_path__ + "static/media/showcase_night_mobile@2x.b897f63d.png";